




























import { Component, Vue } from "vue-property-decorator";
import { deleteDesignButtontyle } from "@/services/styles/designButtonStylesService";

    @Component
export default class StyleDeleteModal extends Vue {
        designButtonStyleToBeDeleted = "";
        name = "";
        isSaved: boolean = false;

        // Methods
        handleEnter(e: KeyboardEvent) {
            if (e.key === "Enter") this.confirmDelete();
        }

        removeEvent() {
            window.removeEventListener("keydown", this.handleEnter);
            this.isSaved = false;
        }

        open(styleId: string, name: string) {
            this.name = name;
            this.designButtonStyleToBeDeleted = styleId;
            this.$bvModal.show("modal-deleteDesignButtonStyle");
            window.addEventListener("keydown", this.handleEnter);
        }

        declineDelete() {
            this.$bvModal.hide("modal-deleteDesignButtonStyle");
            this.designButtonStyleToBeDeleted = "";
        }

        confirmDelete() {
            if (this.isSaved) return;
            this.isSaved = true;
            deleteDesignButtontyle(this.designButtonStyleToBeDeleted).then(() => {
                this.$emit("reload");
                this.designButtonStyleToBeDeleted = "";
                this.$bvModal.hide("modal-deleteDesignButtonStyle");
            });
        }
}
